import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import Loader from "../components/Layout/Loader";
import { loadSellers, setActiveSeller } from "../redux/actions/user";
import { getStoredCurrentProfile } from "../utils/shopProfile";

const SellerProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const { handle } = useParams();
  const sellerLoadAttempted = useRef(false);
  const { isAuthenticated, loading: userLoading } = useSelector((state) => state.user);
  const { isLoading, isSeller, seller, sellers } = useSelector((state) => state.seller);
  const storedCurrentProfile = getStoredCurrentProfile();
  const requestedSeller = handle
    ? sellers.find((sellerProfile) => sellerProfile.handle?.toLowerCase() === handle.toLowerCase())
    : sellers.find((sellerProfile) => sellerProfile.name === storedCurrentProfile)
      || sellers.find((sellerProfile) => sellerProfile._id === seller?._id)
      || sellers[0]
      || null;

  useEffect(() => {
    if (isAuthenticated && sellers.length === 0 && !sellerLoadAttempted.current) {
      sellerLoadAttempted.current = true;
      dispatch(loadSellers());
    }
  }, [dispatch, isAuthenticated, sellers.length]);

  useEffect(() => {
    if (requestedSeller && seller?._id !== requestedSeller._id) {
      dispatch(setActiveSeller(requestedSeller));
    }
  }, [dispatch, requestedSeller, seller?._id]);

  if (userLoading || isLoading || (requestedSeller && seller?._id !== requestedSeller._id)) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to={`/login?redirect=${encodeURIComponent(window.location.pathname)}`} replace />;
  }

  if (!requestedSeller || !isSeller || !seller) {
    return <Navigate to="/shop-login" replace />;
  }

  return children;
};

export default SellerProtectedRoute;
